import * as React from 'react';
import clsx from 'clsx';

type CheckboxAttributes = React.InputHTMLAttributes<HTMLInputElement>;

type Props = {
  label: string;
  id: CheckboxAttributes['id'];
  disabled?: CheckboxAttributes['disabled'];
  checked?: CheckboxAttributes['checked'];
  onChange?: CheckboxAttributes['onChange'];
  large?: boolean;
};

const Checkbox = ({ label, id, disabled = false, checked = false, onChange, large = false }: Props) => {
  return (
    <div className="flex cursor-pointer items-center gap-8 px-8 md:px-16">
      <input
        id={id}
        checked={checked}
        disabled={disabled}
        type="checkbox"
        className="checked:hover:[&:not(:disabled)]:border-red-7 peer h-16 w-16 cursor-pointer appearance-none rounded-4 border-1 border-black-25 bg-[#E1E1E2] transition-all checked:border-4 checked:border-red-100 checked:bg-white-100 disabled:cursor-not-allowed disabled:border-black-25 disabled:bg-black-25 hover:[&:not(:disabled):not(:checked)]:border-black-100"
        onChange={onChange}
      />
      <label
        htmlFor={id}
        className={clsx('text-black-10 peer-disabled:text-black-25', {
          'label-lg': large,
          'label-md': !large,
        })}
      >
        {label}
      </label>
    </div>
  );
};
export default Checkbox;
